import { render, staticRenderFns } from "./domainNamerRealname.vue?vue&type=template&id=5e7b422e&scoped=true&"
import script from "./domainNamerRealname.vue?vue&type=script&lang=js&"
export * from "./domainNamerRealname.vue?vue&type=script&lang=js&"
import style0 from "./domainNamerRealname.vue?vue&type=style&index=0&id=5e7b422e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7b422e",
  null
  
)

export default component.exports